/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateEmergencyEmailLanguageRequest
 */
export interface UpdateEmergencyEmailLanguageRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateEmergencyEmailLanguageRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmergencyEmailLanguageRequest
     */
    language_code: string;
}

/**
 * Check if a given object implements the UpdateEmergencyEmailLanguageRequest interface.
 */
export function instanceOfUpdateEmergencyEmailLanguageRequest(value: object): value is UpdateEmergencyEmailLanguageRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('language_code' in value) || value['language_code'] === undefined) return false;
    return true;
}

export function UpdateEmergencyEmailLanguageRequestFromJSON(json: any): UpdateEmergencyEmailLanguageRequest {
    return UpdateEmergencyEmailLanguageRequestFromJSONTyped(json, false);
}

export function UpdateEmergencyEmailLanguageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEmergencyEmailLanguageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'language_code': json['language_code'],
    };
}

export function UpdateEmergencyEmailLanguageRequestToJSON(json: any): UpdateEmergencyEmailLanguageRequest {
    return UpdateEmergencyEmailLanguageRequestToJSONTyped(json, false);
}

export function UpdateEmergencyEmailLanguageRequestToJSONTyped(value?: UpdateEmergencyEmailLanguageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'language_code': value['language_code'],
    };
}

